/*
 * @Author: Teemo Ding
 * @Date: 2021-09-24 08:53:23
 * @LastEditTime: 2021-09-27 14:39:31
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/logistics/destinationLanguages.ts
 */
import { get, post } from 'src/tools/server';

export const getDestinationLanguages = (params?) =>
  get<any>(
    `/portal/setting/store/logistics/destinationLanguages`,
    params || {},
  );

export const getDestinationLanguagesDetail = (countryCode) =>
  get<any>(
    `/portal/setting/store/logistics/subdivisionsI18n/${countryCode}`,
    {},
  );

export const resetDestinationLanguagesDetail = (countryCode) =>
  get<any>(
    `/portal/setting/store/logistics/subdivisionsI18n/default/${countryCode}`,
    {},
  );

export const saveDestinationLanguagesDetail = (data, params?) =>
  post<any>(
    `/portal/setting/store/logistics/subdivisionsI18n`,
    data,
    params || {},
  );
